// extracted by mini-css-extract-plugin
export var legendIndicator = "_fg-1";
export var legendRight = "_fg-0";